import { ENV } from 'settings.js'
import { Visualizer } from '@uirouter/visualizer'

export function addVisualizer($uiRouter) {
  'ngInject'
  if (ENV.NODE_ENV === 'development' && ENV.UI_ROUTER_VISUALIZER) {
    $uiRouter.plugin(Visualizer)
  }
}
